<script lang="ts" setup>
import { idObjectSchema } from '~/server/schemas'

definePageMeta({
  auth: false,
  layout: 'machinery',
})

const { params } = useRoute()
const { id } = idObjectSchema.parse(params)
</script>

<template>
  <CustomerModuleMachineryDetailsPage :machinery-id="id" />
</template>
